module.exports = __webpack_public_path__ + "static/media/gitlab-plain.9b6b498d.svg";